import { Cartao, ListaDeDados, type Dado } from '../../../components/ListaDeDados'
import { TERMOS } from '../../../lib/glossario'
import type { DetalheChamado } from '../../../types/chamado'

const DESCRICAO =
  'O que a fonte registrou. A categoria daqui é sugestão: o contrato permite reclassificar o serviço ' +
  'depois do diagnóstico.'

/**
 * Como o e-Niterói classificou o chamado.
 *
 * Tudo aqui é o que a FONTE observou, sem julgamento nenhum — a análise da fiscalização tem cartão
 * próprio, logo abaixo. A separação é a mesma que o backend faz na resposta, e existe porque quando
 * um número é contestado a única pergunta que importa é se o dado veio do sistema ou de alguém.
 *
 * Urgência, impacto e prioridade vão como números porque é assim que o e-Niterói os grava, e
 * traduzi-los para "Alta/Média/Baixa" aqui exigiria repetir a tabela de conversão dele — que não
 * está em lugar nenhum deste sistema e mudaria sem ninguém saber. O rótulo diz que é a escala do
 * e-Niterói; quem confere abre o chamado lá e vê o mesmo número.
 *
 * @param props o chamado
 * @returns o cartão de classificação
 */
export function PainelDaClassificacao({ chamado }: { chamado: DetalheChamado }) {
  const campos: Dado[] = [
    { rotulo: 'Categoria no e-Niterói', valor: chamado.categoria },
    { rotulo: 'Tipo', valor: chamado.tipo },
    { rotulo: 'Situação no e-Niterói', valor: chamado.situacaoExterna },
    { rotulo: TERMOS.origemDaDemanda.rotulo, valor: chamado.origemDemandaRotulo },
    { rotulo: 'Prioridade (escala do e-Niterói)', valor: numero(chamado.prioridade) },
    { rotulo: 'Urgência (escala do e-Niterói)', valor: numero(chamado.urgencia) },
    { rotulo: 'Impacto (escala do e-Niterói)', valor: numero(chamado.impacto) },
    { rotulo: 'Código do grupo no e-Niterói', valor: numero(chamado.grupoExternoId) },
  ]

  return (
    <Cartao
      titulo="Como o e-Niterói classificou"
      descricao={DESCRICAO}
    >
      <ListaDeDados dados={campos} />
    </Cartao>
  )
}

/** Número que pode não vir. `0` é valor e precisa aparecer — por isso a checagem é contra nulo. */
function numero(valor: number | null) {
  return valor == null ? null : String(valor)
}
